import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#004D72",
      light: "#07902E",
    },
    _orange: {
      main: "#fa4706",
    },
    secondary: {
      main: "#07902E",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "unset",
          minWidth: "unset",
        },
      },
    },
    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          backgroundColor: "#93CFEC", // Custom background color
          color: "#ffffff", // Text color
          fontWeight: "bold", // Bold text
        },
      },
    },
  },
  typography: {
    fontFamily: "Gotham, Montserrat, sans-serif", // Gotham with Montserrat as fallback
    h1: {
      fontFamily: "Gotham Black, Montserrat, sans-serif",
    },
    h2: {
      fontFamily: "Gotham Bold, Montserrat, sans-serif",
    },
    h3: {
      fontFamily: "Gotham Regular, Montserrat, sans-serif",
    },
    subtitle1: {
      fontFamily: "Gotham Regular, Montserrat, sans-serif",
    },
    body1: {
      fontFamily: "Gotham, Montserrat, sans-serif",
    },
    body2: {
      fontFamily: "Gotham, Montserrat, sans-serif",
    },
  },
});

export default theme;

export const getTableTheme = () =>
  createTheme({
    components: {
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            backgroundColor: "#93CFEC", // Custom background color
            color: "#ffffff", // Text color
            fontWeight: "bold", // Bold text
          },
        },
      },
    },
  });
